import { LineStroke } from "@nova/constants"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { iconByStrokeType } from "./constants"

export const LinePatternPicker = ({
    selectedPattern,
    setSelectedPattern,
    setOpenDropdownId,
}: {
    selectedPattern: LineStroke
    setSelectedPattern: (pattern: LineStroke) => void
    setOpenDropdownId: (id: string | undefined) => void
}) => {
    return (
        <div className="rounded-xl flex gap-2 p-2 bg-gray-700 shadow-card relative items-center">
            {iconByStrokeType.map(([pattern, Icon]) => (
                <div
                    key={pattern}
                    className={classNames("relative rounded-[0.4375rem] border cursor-pointer", {
                        "border-gray-0 text-gray-0": selectedPattern === pattern,
                        "border-transparent text-gray-100 hover:text-gray-0":
                            selectedPattern !== pattern,
                    })}
                    onClick={() => {
                        setSelectedPattern(pattern)
                        setOpenDropdownId(undefined)
                    }}
                >
                    <Icons.Icon Icon={Icon} />
                </div>
            ))}
        </div>
    )
}
